"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = exports.yearNumber = exports.getNearlyEndOfYear = exports.getNearlyStartOfYear = void 0;
/**
 * Returns a date CLOSE to the the start of the year for a given date.
 * Why close to? Because timezones are hard and TupuAke doesn't
 * accept dates that are too close to the start of the year.
 *
 * @param dateString - The date string in the format 'YYYY-MM-DD'.
 * @returns The start of the year in the format 'YYYY-01-02'.
 */
function getNearlyStartOfYear(dateString) {
    const year = new Date(dateString).getFullYear();
    return `${year}-01-02`;
}
exports.getNearlyStartOfYear = getNearlyStartOfYear;
/**
 * Returns a date CLOSE to the end of the year for a given date.
 * Why close to? Because timezones are hard and TupuAke doesn't
 * accept dates that are too close to the end of the year.
 *
 * @param dateString - The date string in the format 'YYYY-MM-DD'.
 * @returns The end of the year in the format 'YYYY-12-30'.
 */
function getNearlyEndOfYear(dateString) {
    const year = new Date(dateString).getFullYear();
    return `${year}-12-30`;
}
exports.getNearlyEndOfYear = getNearlyEndOfYear;
/**
 * Returns a 4 digit year from a given date string.
 *
 * @param dateString - The date string in the format 'YYYY-MM-DD'.
 * @returns The year in the format 'YYYY'.
 */
function yearNumber(dateString) {
    return new Date(dateString).getFullYear();
}
exports.yearNumber = yearNumber;
/**
 * Formats a date string as 'yyyy-mm-dd'.
 *
 * @param dateString - The date string to format.
 * @returns The formatted date string.
 */
function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
exports.formatDate = formatDate;
